export default ({ apiService }) => {
	const strategy = {
		whattsapp: async ({ data, auth, dispatch, actions, maps }) => {
			const { setLoading } = actions;

			const { loading } = data;

			const { mapCouponsData } = maps;

			if (loading && loading.length && loading.indexOf("coupons") > -1) {
				return false;
			}

			dispatch(setLoading("coupons"));

			const url = `WhatsApp/ListarCupons`;
			const result = await apiService.get(url, auth);
			const mappedResult = mapCouponsData(result.data);

			return mappedResult;
		},
		coupons: async ({ data, auth, dispatch, actions, maps }) => {
			const { setLoading } = actions;

			const { loading } = data;

			const { mapCouponsData } = maps;

			if (loading && loading.length && loading.indexOf("coupons") > -1) {
				return false;
			}

			dispatch(setLoading("coupons"));

			const url = `Cupons/Listar`;
			const result = await apiService.get(url, auth);
			const mappedResult = mapCouponsData(result.data);

			return mappedResult;
		},
		add: async ({ data, auth, dispatch, actions, maps }) => {
			const { setLoading } = actions;

			const { loading } = data;

			const { mapCouponData, mapCouponRequest } = maps;

			if (loading && loading.includes("add-coupon")) {
				return false;
			}

			dispatch(setLoading("add-coupon"));

			const url = `Cupons/Cadastrar`;
			const result = await apiService.post(url, mapCouponRequest(data), auth);
			const mappedResult = mapCouponData(result.data);

			return mappedResult;
		},
		addWhattsapp: async ({ data, auth, dispatch, actions, maps }) => {
			const { setLoading } = actions;

			const { loading } = data;

			const { mapCouponData, mapCouponRequest } = maps;

			if (loading && loading.includes("add-coupon")) {
				return false;
			}

			dispatch(setLoading("add-coupon"));

			const url = `WhatsApp/CadastrarCupom`;
			const result = await apiService.post(url, mapCouponRequest(data), auth);
			const mappedResult = mapCouponData(result.data);

			return mappedResult;
		},
	};

	return {
		fetchCouponsWhattsApp: async (payload) => {
			return await strategy["whattsapp"](payload);
		},

		fetchCoupons: async (payload) => {
			return await strategy["coupons"](payload);
		},

		addCoupon: async (payload) => {
			return await strategy["add"](payload);
		},

		addCouponWhattsApp: async (payload) => {
			return await strategy["addWhattsapp"](payload);
		},
	};
};
